import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SummaryApi from "../common";

const OakyaStudentReport = () => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
 const collegeOptions = ["SGU", "GHR"];

const [collegeFilter, setCollegeFilter] = useState("SGU"); // default SGU

  const studentsPerPage = 15;

  const getAllStudents = async () => {
    try {
      const response = await fetch(SummaryApi.getAllStudents.url);
      const data = await response.json();
      if (data.status) {
        setStudents(data.data);
      } else {
        console.error("Failed to fetch students");
      }
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    getAllStudents();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleCollegeFilter = (e) => {
    setCollegeFilter(e.target.value);
    setCurrentPage(1);
  };

  // Extract unique college names for dropdown options
  const collegeNames = Array.from(
    new Set(students.map((student) => student.clg_name).filter(Boolean))
  );

 const filterStudents = students.filter((student) => {
  const nameMatch = student.full_name
    .toLowerCase()
    .includes(searchTerm.toLowerCase());
  const mobileMatch = student.mobile_number
    .toLowerCase()
    .includes(searchTerm.toLowerCase());

  const collegeMatch =
    student.clg_name &&
    student.clg_name.toLowerCase() === collegeFilter.toLowerCase();

  return (nameMatch || mobileMatch) && collegeMatch;
});

  const totalPages = Math.ceil(filterStudents.length / studentsPerPage);
  const paginatedStudents = filterStudents.slice(
    (currentPage - 1) * studentsPerPage,
    currentPage * studentsPerPage
  );

const downloadExcel = () => {
  const worksheetData = filterStudents.map((student, index) => {
    let interestedCourse = "";

    try {
      if (Array.isArray(student.intrested_course)) {
        interestedCourse = student.intrested_course.join(", ");
      } else if (
        typeof student.intrested_course === "string" &&
        student.intrested_course.trim().startsWith("[")
      ) {
        const parsed = JSON.parse(student.intrested_course);
        if (Array.isArray(parsed)) {
          interestedCourse = parsed.join(", ");
        } else {
          interestedCourse = student.intrested_course;
        }
      } else {
        interestedCourse = student.intrested_course || "";
      }
    } catch (err) {
      console.warn("Error parsing course for student:", student.student_id);
      interestedCourse = student.intrested_course || "";
    }

    return {
      "S.no": index + 1,               // <-- Use serial number here
      Name: student.full_name,
      Parent: student.parent_name,
      Mobile: student.mobile_number,
      Alternate: student.alternate_mobile_number,
      Email: student.email,
      Qualification: student.qualification,
      "Interested Course": interestedCourse,
      City: student.city,
      Address: student.address,
      CollegeName:student.clg_name 
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(fileData, "Students_Report.xlsx");
};



  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="min-h-screen p-6">
      <div className="flex justify-between mb-4 flex-col md:flex-row gap-4">
        <h1 className="text-xl font-bold">Oakya Student Report</h1>
        <div className="flex items-center gap-2 w-[40%]">
          <input
            type="text"
            placeholder="Search by name or mobile..."
            className="border px-3 py-2 rounded-md w-[70%]"
            value={searchTerm}
            onChange={handleSearch}
          />
        <select
  value={collegeFilter}
  onChange={handleCollegeFilter}
  className="border px-3 py-2 rounded-md w-[40%]"
>
  {collegeOptions.map((name) => (
    <option key={name} value={name}>
      {name}
    </option>
  ))}
</select>
          <button
            onClick={downloadExcel}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded w-[30%]"
          >
            Download Excel
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 shadow-lg rounded-lg">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left px-4 py-2 border">S.no</th>
              <th className="text-left px-4 py-2 border">Name</th>
              <th className="text-left px-4 py-2 border">Parent</th>
              <th className="text-left px-4 py-2 border">Mobile</th>
              <th className="text-left px-4 py-2 border">Alt Mobile</th>
              <th className="text-left px-4 py-2 border">Email</th>
              <th className="text-left px-4 py-2 border">Qualification</th>
              <th className="text-left px-4 py-2 border">Interested Course</th>
              <th className="text-left px-4 py-2 border">City</th>
              <th className="text-left px-4 py-2 border">Address</th>
              <th className="text-left px-4 py-2 border">College Name</th>
            </tr>
          </thead>
          <tbody>
            {paginatedStudents.length > 0 ? (
              paginatedStudents.map((student, index) => {
                let courses = "";
                try {
                  const parsed = JSON.parse(student.intrested_course);
                  courses = Array.isArray(parsed)
                    ? parsed.join(", ")
                    : student.intrested_course;
                } catch {
                  courses = student.intrested_course;
                }

                return (
                  <tr key={student.student_id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">
                      {(currentPage - 1) * studentsPerPage + index + 1}
                    </td>
                    <td className="px-4 py-2 border">{student.full_name}</td>
                    <td className="px-4 py-2 border">{student.parent_name}</td>
                    <td className="px-4 py-2 border">{student.mobile_number}</td>
                    <td className="px-4 py-2 border">
                      {student.alternate_mobile_number}
                    </td>
                    <td className="px-4 py-2 border">{student.email}</td>
                    <td className="px-4 py-2 border">{student.qualification}</td>
                    <td className="px-4 py-2 border">{courses}</td>
                    <td className="px-4 py-2 border">{student.city}</td>
                    <td className="px-4 py-2 border">{student.address}</td>
                     <td className="px-4 py-2 border">{student.clg_name}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="10" className="text-center px-4 py-6">
                  No students found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-between items-center mt-4">
        <p className="text-sm text-gray-600">
          Showing {(currentPage - 1) * studentsPerPage + 1} to{" "}
          {Math.min(currentPage * studentsPerPage, filterStudents.length)} of{" "}
          {filterStudents.length} students
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => handlePageChange("prev")}
            disabled={currentPage === 1}
            className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-50"
          >
            Prev
          </button>
          <span className="text-sm font-medium">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange("next")}
            disabled={currentPage === totalPages}
            className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OakyaStudentReport;
